import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'allSearch'
})
export class AllSearchPipe implements PipeTransform {

  transform(items: any[], searchTerm: string): unknown {
    if (searchTerm) {
      // tslint:disable-next-line:max-line-length
      return items.filter(keyword => keyword.className && keyword.className.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);
    } else {
      return items;
    }
  }

}
